export const mapConfig = {
  centerPoint: [113.761036, 33.497242],
  markPoint: [
    {
      point: [114.067802, 22.638149],
      address: '中国深圳市龙岗区坂田华为总部办公楼',
      company: '华为技术有限公司',
      phone: '18866669991',
      img: require('../assets/partner-all/huawei.svg')
    },
    // {
    //   point: [113.822054, 22.641829],
    //   address: '深圳宝安国际机场',
    //   company: '公司名称2',
    //   phone: '18866668888',
    //   img: require('../assets/partner-all/hp.svg')
    // },
    {
      point: [116.397827, 39.90374],
      address: '北京天安门广场',
      company: '思科',
      phone: '18866668888',
      img: require('../assets/partner-all/cisco.svg')
    },
    {
      point: [112.982277, 28.19409]
    }, {
      point: [110.199890, 20.044220]
    }, {
      point: [106.504959, 29.533155]
    }, {
      point: [103.834170, 36.061380]
    }, {
      point: [115.892151, 28.676493]
    }, {
      point: [118.76741, 32.041546]
    }, {
      point: [120.15358, 30.287458]
    }, {
      point: [114.298569, 30.584354]
    }, {
      point: [102.71225, 25.040609]
    }, {
      point: [108.948021, 34.263161]
    }, {
      point: [119.306236, 26.075302]
    }, {
      point: [123.429092, 41.796768]
    }, {
      point: [117.190186, 39.125595]
    }, {
      point: [112.549248, 37.857014]
    }, {
      point: [113.665413, 34.757977]
    }, {
      point: [108.948021, 34.263161]
    }, {
      point: [108.320007, 22.82402]
    }, {
      point: [104.065735, 30.659462]
    }, {
      point: [91.11450, 29.644150]
    }, {
      point: [106.713478, 26.578342]
    }
  ]
}
